/**
 * salles.js
 * ---------
 * Referentiel des locaux : batiments et salles.
 *
 * Extrait de `directeurApi.js` (559 lignes, toutes les fonctions ajoutees a la
 * suite). Chaque lot ajoutait ses appels en fin de fichier : deux lots ouverts
 * en meme temps entraient donc systematiquement en conflit sur ce fichier.
 * `directeurApi.js` reste le point d'entree — il re-exporte ces modules — pour
 * qu'aucun ecran n'ait a changer ses imports.
 */
import axiosClient from "../axiosClient";

/* ── Référentiel des locaux (salles & bâtiments) ── */

/** GET /directeur/salles/ -> { batiments, salles, stats, non_rattachees, reference } */
export async function getDirecteurSalles() {
  const { data } = await axiosClient.get("/directeur/salles/");
  return data || {};
}

/** POST /salles/ — crée une salle (le CRUD reste servi par le ViewSet générique). */
export async function creerSalle(payload) {
  const { data } = await axiosClient.post("/salles/", payload);
  return data;
}

/** PATCH /salles/<id>/ — met à jour une salle. */
export async function majSalle(id, payload) {
  const { data } = await axiosClient.patch(`/salles/${id}/`, payload);
  return data;
}

/** DELETE /salles/<id>/ */
export async function supprimerSalle(id) {
  await axiosClient.delete(`/salles/${id}/`);
}

/** POST /school/buildings/ — crée un bâtiment. */
export async function creerBatiment(payload) {
  const { data } = await axiosClient.post("/school/buildings/", payload);
  return data;
}
